/* eslint-disable import/prefer-default-export */
export const selectOrderConfirmationReference = (state) =>
  state.order.status.orderConfirmationReference;
